import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

export default function Services() {
  return (
    <>
      {/* HERO SECTION */}
      <div className="hero">
        <div className="hero-content">
          <h1>Our Services</h1>
          <p className="hero-subtext">
            Over 40 years of expertise in electrical motor
            rewinding, repair and performance enhancement.
          </p>

          <ul className="hero-points">
            <li>✔ LT & HT Motor Rewinding</li>
            <li>✔ DC Motors, Generators & Alternators</li>
            <li>✔ Design Improvement & Optimization</li>
            <li>✔ Testing, Balancing & Alignment</li>
          </ul>
        </div>
      </div>

{/* SERVICES GRID */}
<div className="services-grid-wrapper">
  <div className="services-grid">

    <div className="service-card">
      <h3>Motor & Generator Rewinding</h3>
      <p>
        Precision rewinding for LT & HT AC motors, DC motors,
        generators and alternators.
      </p>
      <ul>
        <li>Slot-by-slot rewinding</li>
        <li>Short pitch optimization</li>
        <li>Reduced harmonics</li>
        <li>Improved efficiency</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>Repair & Overhauling</h3>
      <p>
        Complete mechanical and electrical restoration
        for all rotating machines.
      </p>
      <ul>
        <li>Rotor & stator repairs</li>
        <li>Shaft replacement</li>
        <li>End ring replacement</li>
        <li>Bearing housing repairs</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>Winding Design & Engineering</h3>
      <p>
        Engineering-driven winding optimization
        for improved thermal and electrical performance.
      </p>
      <ul>
        <li>Custom stator/rotor design</li>
        <li>Wire gauge optimization</li>
        <li>Copper fill improvement</li>
        <li>Loss reduction</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>Testing & Quality Assurance</h3>
      <p>
        Strict electrical and mechanical testing
        before dispatch.
      </p>
      <ul>
        <li>IR Testing</li>
        <li>Surge Testing</li>
        <li>Core Loss Testing</li>
        <li>Winding Resistance</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>Mechanical Precision Services</h3>
      <p>
        Ensuring smooth and vibration-free operation.
      </p>
      <ul>
        <li>Dynamic balancing</li>
        <li>Bearing replacement</li>
        <li>Alignment checks</li>
        <li>Vibration correction</li>
      </ul>
    </div>

    <div className="service-card service-cta">
      <h3>Why Choose SPSR?</h3>
      <ul>
        <li>40+ Years Experience</li>
        <li>LT & HT Capability</li>
        <li>Performance-focused approach</li>
        <li>Trusted Industrial Partner</li>
      </ul>

      <p>
        <Link to="/contact" className="contact-button">
          Contact Us
        </Link>
      </p>
    </div>

  </div>
</div>
    </>
  );
}